module.exports = __webpack_public_path__ + "img/diamond_bonus-in.f5dd3925.png";